<template>
    <div>
        <v-server-table ref="tradeTable" url="/subcontractors/trade-list" :columns="columns" :options="options">

            <template slot="trade_id" slot-scope="props">
                <router-link :to="`/subcontractors/settings/trades/edit/${props.row.trade_id}`" title="Edit Trade">
                    Edit
                </router-link>
                |
                <a class="text-danger" href="javascript:void(0);" @click="deleteTrade(props.row.trade_id)" title="Delete Trade">
                    Delete
                </a>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['trade_id', 'trade_name'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        trade_id: 'Actions',
                        trade_name: 'Trade Name',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'trades.trade_name',
                    },
                    uniqueKey: 'trade_id',
                },
            }
        },
        methods: {
            deleteTrade: function(trade_id) {
                if (confirm('Are you sure you want to delete this trade? It will be removed from all subcontractors that are using it.'))
                {
                    this.$http
                        .post(`subcontractors/trade-delete/${trade_id}`)
                        .then(response => {
                            this.$toastr.success('Trade Deleted');

                            this.$refs.tradeTable.refresh();
                        })
                        .catch(response => {

                        });
                }
            }
        },
    }
</script>
